module.exports = __webpack_public_path__ + "img/c46ad88.png";